import ScrollReveal from "@/components/base/ScrollReveal";
import SecurityFeaturesGrid from "./components/SecurityFeaturesGrid";
import TestimonialsCarousel from "./components/TestimonialsCarousel";
import WhyChooseSection from "./components/WhyChooseSection";

const productFeatures = [
  "VPN — 1000+ Secure Servers",
  "AdBlock — Block Ads & Trackers",
  "Check IP — Instant Connection Info",
  "Speed Test — Real-Time Speed Check",
];

export default function OurProductPage() {
  return (
    <main>
      {/* Hero Section */}
      <section className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden bg-foreground-900">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900 to-foreground-900" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight font-heading">
            Online Shield — Fast VPN Proxy
          </h1>
          <p className="mt-4 text-lg text-foreground-300 max-w-2xl mx-auto">
            Your Privacy, Secured
          </p>
        </div>
      </section>

      {/* Product Overview */}
      <section className="py-14 md:py-20 bg-white">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <ScrollReveal>
            <div className="text-center mb-10 md:mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4 font-heading">
                Online Shield — Fast VPN Proxy
              </h2>
              <p className="text-lg text-foreground-600 max-w-3xl mx-auto">
                A powerful iOS app that combines VPN, AdBlock, IP checker, and speed test
                to give you complete control over your online privacy and security
              </p>
            </div>
          </ScrollReveal>

          <div className="bg-gradient-to-r from-primary-50/60 to-secondary-100 rounded-2xl p-6 md:p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
              <ScrollReveal delay={100}>
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-6 font-heading">
                    Complete Mobile Protection
                  </h3>
                  <p className="text-base md:text-lg text-foreground-700 mb-6 leading-relaxed">
                    Online Shield — Fast VPN Proxy is our flagship iOS privacy app
                    developed by Web 3.0 Soft Limited. It combines four powerful
                    tools: VPN with access to 1000+ secure servers, AdBlock for
                    customizable content filtering, Check IP for instant connection
                    diagnostics, and Speed Test for real-time network performance.
                  </p>
                  <p className="text-base md:text-lg text-foreground-700 mb-8 leading-relaxed">
                    Whether you are on public Wi-Fi at a cafe or traveling abroad,
                    Online Shield keeps your data encrypted, your identity hidden,
                    and your browsing experience clean and fast.
                  </p>
                  <div className="space-y-4">
                    {productFeatures.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <div className="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                          <i className="ri-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-foreground-700 font-medium text-sm md:text-base">
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal delay={200}>
                <div className="relative flex items-center justify-center">
                  <img
                    src="https://storage.readdy-site.link/project_files/957ceb93-2e28-41dc-87f9-7d664dd26839/3e0b551f-40c7-4727-b50c-7074a9c95890_image-18.png"
                    alt="Online Shield App Icon"
                    className="rounded-2xl object-contain w-[280px] h-[280px] md:w-[320px] md:h-[320px]"
                  />
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </section>

      <ScrollReveal>
        <SecurityFeaturesGrid />
      </ScrollReveal>
      <ScrollReveal>
        <WhyChooseSection />
      </ScrollReveal>
      <ScrollReveal>
        <TestimonialsCarousel />
      </ScrollReveal>
    </main>
  );
}